import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import RoomRegister from "./roomRegister/roomRegister";

import "./matchSetting.css";

const Setting = props => {
	const [piece, setPiece] = useState("customize"); // PV: "random", "customize"
	const [gameTimer, setGameTimer] = useState(0); // PV: 0, 5, 10, 30, 60
	const [moveTimer, setMoveTimer] = useState(0); // PV: 0, 5, 10, 30, 60

	return (
		<div className="match-setting">
			<div className={props.matchSettingVisible ? "match-setting-visible" : "match-setting-hidden"}>
				<div className="holderSide"></div>

				<div
					className="background-clicker"
					onClick={() => {
						props.setMatchSettingVisible(false);
						props.setRoomCategoryVisible(false);
					}}
				/>

				<div className="match-setting-container">
					{/* <button className="btn-back" onClick={() => { props.setMatchSettingVisible(false); props.setRoomCategoryVisible(false); }}> x </button> */}

					<h1 className="piece-title title">Piece:</h1>
					<div className="piece-selection">
						<input
							type="button"
							value="Customize"
							className={piece === "customize" ? "btn-selected" : "btn-option"}
							onClick={() => setPiece("customize")}
						/>

						<input
							type="button"
							value="Random"
							className={piece === "random" ? "btn-selected" : "btn-option"}
							onClick={() => setPiece("random")}
						/>
					</div>

					<div className="game-timer-title">
						<h1 className="title">Game Timer:</h1>
						<h1 className="sub-title">(Mins)</h1>
					</div>
					<div className="game-timer-selection">
						<input
							type="button"
							value="0"
							className={gameTimer === 0 ? "btn-selected" : "btn-option"}
							onClick={() => setGameTimer(0)}
						/>
						<input
							type="button"
							value="5"
							className={gameTimer === 5 ? "btn-selected" : "btn-option"}
							onClick={() => setGameTimer(5)}
						/>
						<input
							type="button"
							value="10"
							className={gameTimer === 10 ? "btn-selected" : "btn-option"}
							onClick={() => setGameTimer(10)}
						/>
						<input
							type="button"
							value="30"
							className={gameTimer === 30 ? "btn-selected" : "btn-option"}
							onClick={() => setGameTimer(30)}
						/>
						<input
							type="button"
							value="60"
							className={gameTimer === 60 ? "btn-selected" : "btn-option"}
							onClick={() => setGameTimer(60)}
						/>
					</div>

					<div className="move-timer-title">
						<h1 className="title">Move Timer:</h1>
						<h1 className="sub-title">(Secs)</h1>
					</div>
					<div className="move-timer-selection">
						<input
							type="button"
							value="0"
							className={moveTimer === 0 ? "btn-selected" : "btn-option"}
							onClick={() => setMoveTimer(0)}
						/>
						<input
							type="button"
							value="5"
							className={moveTimer === 5 ? "btn-selected" : "btn-option"}
							onClick={() => setMoveTimer(5)}
						/>
						<input
							type="button"
							value="10"
							className={moveTimer === 10 ? "btn-selected" : "btn-option"}
							onClick={() => setMoveTimer(10)}
						/>
						<input
							type="button"
							value="30"
							className={moveTimer === 30 ? "btn-selected" : "btn-option"}
							onClick={() => setMoveTimer(30)}
						/>
						<input
							type="button"
							value="60"
							className={moveTimer === 60 ? "btn-selected" : "btn-option"}
							onClick={() => setMoveTimer(60)}
						/>
					</div>
					<RoomRegister placeholder="Chat Room" roomDuty={props.isRoomJoin ? "join_chat" : "create_chat"} />
				</div>
			</div>
		</div>
	);
};

export default Setting;
